import { Usuario } from "../interfaces/Usuario";
import { useAction } from "./useAction";
import { cadastrarUsuarioService } from "../services/cadastrarUsuarioService";

export const useCadastrarUsuario = () => {
  const {
    execute: cadastrarUsuario,
    isLoading,
    data,
    error,
    success,
  } = useAction<Usuario>(cadastrarUsuarioService);

  const handleSubmit = async (usuario: Usuario) => {
    try {
      const response = await cadastrarUsuario(usuario);
      console.log("Proprietário cadastrado com sucesso", response);
      return response;
    } catch (error) {
      console.error("Erro ao cadastrar proprietário", error);
      throw error; // propaga erro para quem chamou
    }
  };

  return {
    handleSubmit,
    isLoading,
    data,
    error,
    success,
  };
};
